<template>
  <div class="searchable-drop-down">
    <div class="filter-header" @click="$emit('click', $event)">
      <icon size="18">place</icon>
      <p class="selected">
        {{ value ? (value.name ? value.name : placeholder) : placeholder }}
      </p>
      <icon :class="[{ rotate: isDropped }]">arrow_drop_down</icon>
    </div>
    <!-- <SlideYUpTransition>
      <div v-if="isDropped" :class="['options-wrapper', 'smooth-shadow']">
        -->
    <!-- show search on top if not dropup -->
    <!--
        <input
          v-if="!dropup"
          type="text"
          v-model="searchTerm"
          class="mar-5"
          placeholder="search"
          @click.stop="activate()"
        />
        <simplebar
          class="list-wrapper"
          data-auto-hide="false"
          scrollbarMaxSize="30"
        >
          <div :class="['options']">
            <div
              class="option"
              v-for="(option, index) in filteredOptions"
              :key="index"
              @click="selectItem(option)"
            >
              <p class="ellipsis">{{ option.name }}</p>
              <p class="ellipsis description" v-if="option.description">
                {{ option.description }}
              </p>
            </div>
            <div v-if="getFetchingCities">
              <LoadingBar />
            </div>
            <div
              v-else-if="filteredOptions.length == 0"
              class="option no-results"
            >
              No options
            </div>
          </div>
        </simplebar>
      </div>
    </SlideYUpTransition> -->
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    placeholder: String,
    options: Array,
    value: Object || String,
    dropup: Boolean,
    getFetchingCities: Boolean,
  },
  data: () => ({
    selected: {
      id: "",
      name: "",
    },
    isDropped: false,
    searchTerm: "",
  }),
  computed: {
    filteredOptions() {
      const regex = new RegExp(this.searchTerm, "i");
      return this.options
        .filter(item => regex.test(item.name))
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .sort((a, b) =>
          a.description && b.description
            ? a.description > b.description
              ? 1
              : b.description > a.description
              ? -1
              : 0
            : 0
        );
    },
  },
  methods: {
    toggleDropDown() {
      this.isDropped = !this.isDropped;
    },
    closeDropDown() {
      this.isDropped = false;
    },
    removeListener() {
      this.closeDropDown();
      document.removeEventListener("click", this.removeListener, false);
    },
    selectItem(option) {
      this.isDropped = false;
      this.selected = option;
      this.$emit("input", option);
    },
    activate() {},
  },
  watch: {
    isDropped(value) {
      if (value) {
        this.searchTerm = "";
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.searchable-drop-down {
  position: relative;

  .filter-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: var(--color-default-background);
    transition: 0.2s all ease-in-out;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    padding: 0 10px;
    z-index: 100;
    width: 200px;
    /* margin: 0 10px; */

    p {
      margin: 0;
      padding: 12px 15px 12px 15px;
      flex: 1;
    }

    i {
      transition: 0.2s all ease-in-out;

      &.caret {
        margin: 0 0 0 5px;
      }
    }

    .rotate {
      transform: rotate(180deg);
    }

    &:hover {
      cursor: pointer;
      border: 1px solid var(--color-accent);
    }

    &:active {
      opacity: 0.7;
    }
  }

  /* &:hover {
    border: 1px solid var(--color-accent);
  }

  i {
    position: absolute;
    right: 10px;
    bottom: 9px;
  } */

  .options-wrapper {
    position: absolute;
    width: 100%;
    z-index: 99;
    top: 50px;
    background: var(--color-secondary);
    border: 1px solid var(--border-color);
    border-radius: 5px;

    &.dropup {
      top: auto !important;
      bottom: 50px !important;
    }

    .list-wrapper {
      overflow: auto;
      max-height: 250px;
    }
  }

  .options {
    overflow: auto;

    &:last-child {
      border-bottom: 0 !important;
    }
    .option {
      border-bottom: 1px solid var(--border-color);
      padding: 10px;
      display: flex;
      flex-direction: column;

      &:hover {
        background-color: var(--border-color);
        cursor: pointer;
      }

      p {
        margin: 0;
      }

      p.description {
        opacity: 0.7;
        font-size: 0.9em;
      }
    }
  }

  .no-results {
    cursor: default !important;
    text-align: center;
    &:hover {
      background: var(--color-secondary) !important;
    }
  }

  .selected {
    border-bottom: 0;
    padding: 10px 20px 10px 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    transition: 0.2s all ease-in-out;

    &:hover {
      border-bottom: 2px solid var(--color-accent);
      cursor: pointer;
    }

    &:hover {
      border-bottom: 0;
      cursor: pointer;
    }
  }
}
</style>
